import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },

  text: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova', sans-serif",
    color: '#011533',
    marginTop: '12px',
    marginBottom: '12px',
  },

  nmbrsModalButton: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova' sans-serif",
    color: '#011533',
    marginTop: '12px',
    marginBottom: '12px',
    cursor: 'pointer',
    '&:hover': {
      color: 'blue',
    },
  },

  notProvidedText: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova' sans-serif",
    color: 'red',
  },

  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },
  buttonLabel: {
    fontSize: 16,
    color: theme.colors.primary,
  },
  active: {
    '& > p': {
      color: theme.colors.primary,
    },
  },
  disabled: {
    '& > p': {
      color: '#737373',
    },
  },

  noValue: {
    '& > p': {
      color: '#B6B6B6',
    },
  },

  table: {
    textAlign: 'center',
    borderRadius: '4px',

    '&  p': {
      fontSize: '14px',
    },
  },

  tableContainer: {
    maxHeight: '600px',
  },

  tableHead: {
    background: 'white',
    '& th': {
      padding: '0 10px !important',
    },
  },
  tableRow: {
    marginBottom: 12,
    '& > div:first-child': {
      marginBottom: '0px',
    },
    '& td': {
      marginBottom: '0px !important',
      borderBottom: '1px solid #E2E2FC',
      padding: '0 10px !important',
    },
  },

  tableHeaderCell: {
    width: '100px',
    background: 'white',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: 'red',
    whiteSpace: 'nowrap',
  },

  firstTableHeaderCell: {
    width: '200px',
    background: 'white',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    fontWeight: '400',
    color: 'red',
  },

  tableValue: {
    width: '100px',
  },
  tableHeadersLabel: {
    background: 'white',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: '#707087',
  },
  commentIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: '-18px',
    zIndex: 10,
  },
  comment: {
    display: 'flex',
    position: 'relative',
  },
  minWidth: {
    minWidth: '116px',
  },
  commentWrapper: {
    '& th': {
      padding: '0 30px 0 10px !important',
    },
  },
}

export default styles
